import { render } from "./quickViewComponent.vue?vue&type=template&id=046874a1&scoped=true"
import script from "./quickViewComponent.vue?vue&type=script&lang=js"
export * from "./quickViewComponent.vue?vue&type=script&lang=js"

import "./quickViewComponent.vue?vue&type=style&index=0&id=046874a1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046874a1"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/quickViewComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "046874a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('046874a1', __exports__)) {
    api.reload('046874a1', __exports__)
  }
  
  module.hot.accept("./quickViewComponent.vue?vue&type=template&id=046874a1&scoped=true", () => {
    api.rerender('046874a1', render)
  })

}


export default __exports__